import {useMemoizedValue} from '@sail/react';
import {useEffect} from 'react';
import useLazyBaseFetch from 'src/internal/fetch/useLazyBaseFetch';

import type {
  FetchHookOptions,
  FetchState,
  FetchUrl,
} from 'src/internal/shared/fetch/types';

export default function useBaseFetch<TData = unknown>(
  url: FetchUrl,
  options: FetchHookOptions<TData>,
  format: 'text' | 'json',
): FetchState<TData> {
  const [callback, {called, loading, ...rest}] = useLazyBaseFetch(
    url,
    options,
    format,
  );

  const result = useMemoizedValue({
    called: true,
    loading: called ? loading : true,
    ...rest,
  });

  useEffect(() => {
    callback();
  }, [callback]);

  return result;
}
